import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { OptionsObject, SnackbarKey, SnackbarMessage, useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import useDebugInformation from '../../../hooks/useDebugInformation';
import { ui } from '../../../interfaces/interfaces';
import { useAppSelector } from "@store/hooks";

const name = "SnackBarDrop"

const isLoading = (loading: boolean, done: boolean) => !loading && done ? false : true

type Props = {
    parent: string
}

const SnackBarDrop: React.FC<Props> = ({ parent }) => {
    const problemShowMsg = useAppSelector(({ ui }) => ui.ProblemShowMsg)
    const loading = useAppSelector(({ ui }) => ui.Loading)
    const done = useAppSelector(({ ui }) => ui.Done)
    const problemMsg = useAppSelector(({ ui }) => ui.ProblemMsg)
    const problemMsgVariant = useAppSelector(({ ui }) => ui.ProblemMsgVariant)

    const showSnackBar = React.useCallback((enqueueSnackbar: {
        (message: SnackbarMessage, options?: OptionsObject | undefined): SnackbarKey; (arg0: any, arg1: { variant: any; }): any;
    }) => {
        enqueueSnackbar(problemMsg, { variant: problemMsgVariant });
        ui.ProblemShowMsg = false;
    }, [problemMsg, problemMsgVariant])

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        problemShowMsg && showSnackBar(enqueueSnackbar)
    }, [enqueueSnackbar, problemShowMsg, showSnackBar])

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { done, loading, problemMsg, problemMsgVariant, problemShowMsg })

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: 1600 }}
            open={isLoading(loading, done)}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}

export default React.memo(SnackBarDrop)
